import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/auth-context';
import { Loader2 } from 'lucide-react';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isConnected, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-sg-dark flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-8 h-8 text-sg-accent animate-spin mx-auto mb-4" />
          <p className="text-gray-400 text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isConnected) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
